import React from 'react'
import "../components/css/services.css"

const Service = () => {
  return (
  <>

<div className = "Service-container">

<div className="servicesbox">
  <div className="imgs"><img src="./images/web.jpg" alt="" />
  </div>
  <div className="para">
  <h1>Web Development</h1>

 
  </div>
</div>

<div className="servicesbox2">
  <div className="imgs"><img src="./images/startup.jpg" alt="" />
  </div>
  <div className="para">
    <h1>Website making for new Start Up</h1>

  </div>
</div>

<div className="servicesbox">
  <div className="imgs"><img src="./images/freelencer.jpg" alt="" />
  </div>
  <div className="para">
    <h1>Freelancer</h1>

  </div>
</div>

</div> 
  </>
  
  )
}

export default Service

